// Sehr leichter YAML-Frontmatter-Parser — nur das, was vault-writer schreibt.
// Unterstuetzt Top-Level-Strings, Numbers, Booleans und einfache "- item"-Listen.

export interface ParsedFrontmatter {
  data: Record<string, unknown>
  body: string
}

const FRONTMATTER_RE = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?/

export function parseFrontmatter(content: string): ParsedFrontmatter {
  const match = content.match(FRONTMATTER_RE)
  if (!match) return { data: {}, body: content }
  const yamlBlock = match[1] ?? ''
  const body = content.slice(match[0].length)
  return { data: parseYamlBlock(yamlBlock), body }
}

function parseYamlBlock(block: string): Record<string, unknown> {
  const lines = block.split(/\r?\n/)
  const result: Record<string, unknown> = {}

  let currentListKey: string | null = null
  let currentList: string[] = []

  const flushList = () => {
    if (currentListKey != null) {
      result[currentListKey] = currentList
      currentListKey = null
      currentList = []
    }
  }

  for (const line of lines) {
    if (!line.trim()) continue

    // Listen-Item "  - value"
    const listItem = line.match(/^\s+-\s+(.*)$/)
    if (listItem && currentListKey != null) {
      currentList.push(unquote(listItem[1] ?? ''))
      continue
    }

    // Key: Value oder Key:
    const kv = line.match(/^([A-Za-z0-9_]+)\s*:\s*(.*)$/)
    if (!kv) continue
    flushList()

    const key = kv[1]!
    const rawValue = (kv[2] ?? '').trim()

    if (rawValue === '') {
      currentListKey = key
      currentList = []
      continue
    }
    if (rawValue === '[]') {
      result[key] = []
      continue
    }

    result[key] = coerce(rawValue)
  }
  flushList()

  return result
}

function unquote(s: string): string {
  const t = s.trim()
  if ((t.startsWith('"') && t.endsWith('"')) || (t.startsWith("'") && t.endsWith("'"))) {
    return t.slice(1, -1).replace(/\\"/g, '"')
  }
  return t
}

function coerce(raw: string): unknown {
  const v = unquote(raw)
  if (v === 'true') return true
  if (v === 'false') return false
  if (v === 'null' || v === '') return null
  if (/^-?\d+$/.test(v)) return Number(v)
  return v
}

// ---------- Helpers fuer Konsumenten ----------

export function fmString(data: Record<string, unknown>, key: string): string | null {
  const v = data[key]
  return typeof v === 'string' && v ? v : null
}

export function fmNumber(data: Record<string, unknown>, key: string): number | null {
  const v = data[key]
  return typeof v === 'number' ? v : null
}
